/**
 * Internal dependencies
 */
import { CONNECTION_LOST, CONNECTION_RESTORED } from 'state/action-types';
import { createReducer } from 'state/utils';

export default createReducer('CHECKING', {
	[CONNECTION_LOST]: () => 'OFFLINE',
	[CONNECTION_RESTORED]: () => 'ONLINE',
});
